
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class AuthTitle extends Vue {
    @Prop({ type: String, required: true }) readonly content!: string;
    @Prop({ type: Boolean, default: false }) readonly small!: boolean;

    get classes(): Record<string, boolean> {
      return {
        "text-4xl md:text-5xl": !this.small,
        "text-3xl": this.small,
      };
    }
  }
